import React from "react";
import styled from "styled-components";
import { colors, font, Image } from "@literati/public-ui-shared-react";
import {
  bookShuffleCardSharedStyles,
  bookShuffleDeckCardSizeStyles,
} from "components/bookShuffle/bookShuffleStyles";
import useBookShuffle from "components/bookShuffle/useBookShuffle";

/** This is the className that will be pre-pended to all of BookShuffleCardCompleted's inner component classNames */
export const BOOK_SHUFFLE_CARD_COMPLETED_CLASS_BASE =
  "book-shuffle-card-completed";

/** These are all of the internal classNames that are used within the BookShuffleCardCompleted component */
export const BookShuffleCardCompletedClassName = {
  BASE: BOOK_SHUFFLE_CARD_COMPLETED_CLASS_BASE,
  TITLE: `${BOOK_SHUFFLE_CARD_COMPLETED_CLASS_BASE}-title`,
  DESCRIPTION: `${BOOK_SHUFFLE_CARD_COMPLETED_CLASS_BASE}-description`,
} as const;

const CardDiv = styled.div`
  ${bookShuffleCardSharedStyles}
  ${bookShuffleDeckCardSizeStyles}
  flex-direction: column;
  align-items: center;
  padding: 4.5rem 0 0;
`;

const StyledImage = styled(Image)`
  width: 160px;
  height: 160px;
`;

const StyledTitle = styled.h1`
  font-family: ${font.fontFamily.avenir};
  font-weight: 900;
  font-size: 1.125rem;
  line-height: 1.375rem;
  text-align: center;
  color: ${colors.inkBlack};
`;

const StyledDescription = styled.div`
  margin: 0.75rem 1.25rem 0;
  font-family: ${font.fontFamily.avenir};
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-align: center;
  color: ${colors.warmGray3};
`;

export interface BookShuffleCardCompletedProps {
  className?: string;
}

export const BookShuffleCardCompleted = ({
  className = "",
}: BookShuffleCardCompletedProps) => {
  const cls = BookShuffleCardCompletedClassName;

  const {
    endDescription = "Thanks for helping to make your reader’s experience even better! Play Book Shuffle from your account anytime to further refine personalization.",
  } = useBookShuffle();

  return (
    <CardDiv className={`${cls.BASE} ${className}`}>
      <StyledImage
        src={
          "https://images.ctfassets.net/vqtz4cq2w5ts/3AARXtRjNWKZW2n5stArrF/a030f68d4db689db6580cc017ac696b9/image_3.png"
        }
        width={160}
        height={160}
        aria-hidden
        alt=""
      />
      <StyledTitle className={cls.TITLE}>Woohoo! You did it.</StyledTitle>
      <StyledDescription className={cls.DESCRIPTION}>
        {endDescription}
      </StyledDescription>
    </CardDiv>
  );
};

export default BookShuffleCardCompleted;
